import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: false,
  emailVerified: false,
  loading: false,
  prefilledLoginEmail: '',
  prefilledSignupEmail: '',
  prefilledSignupEmailDisabled: false,
  actionLogout: false,
  signupEmail: '',
  betaCustomer: false,
  openLastVisitedApp: false,
  customerContext: {},
  loginEmail: '',
  loginPassword: '',
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
